import { Container } from './style/styled';

export const Overview = () => {
  return <Container>Warehouse overview</Container>;
};
